import script from "./VideoSlideShowPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSlideShowPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoSlideShowPage.vue?vue&type=style&index=0&id=1890459e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1890459e"]])

export default __exports__